var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.8585,
    y: 5.8042,
    width: 9.82275,
    height: 3.68353,
    transform: "rotate(45 26.8585 5.8042)",
    fill: "#474751"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 10.5796L29.029 17.5253L17.3081 29.2463L9.27705 30.3315L10.3623 22.3005L22.0833 10.5796Z",
    fill: "#474751"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.91440f4bff9bd5be958571a3d9c2845c.svg";
export { ForwardRef as ReactComponent };